import { Accordion, Badge, Button, Stack } from "react-bootstrap";
import { StarFill } from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

function GameExtraction({ accordionIndex, extraction, onSearchProductClicked, onDeleteExtractionClicked, onSelectGameClicked }) {
    const { t } = useTranslation('messages');

    return (
        <Accordion.Item eventKey={accordionIndex} className="border-0 shadow-sm mb-2 rounded">
            <Accordion.Header>
                <Stack direction="horizontal" gap={2} className="d-inline-flex flex-wrap">
                    <Badge bg="secondary">{extraction.creation_time}</Badge>
                    {extraction.game_filters.map((filter) => (
                        <Badge bg="success" key={filter.game_label_id}>{filter.name}</Badge>
                    ))}
                    {extraction.game_negative_filters.map((filter) => (
                        <Badge bg="danger" key={filter.game_label_id}>{filter.name}</Badge>
                    ))}
                </Stack>
            </Accordion.Header>
            <Accordion.Body style={{ backgroundColor: '#fdf4ff' }}>
                <div className="mb-3">
                    <Button size="sm" variant="outline-danger" onClick={(e) => onDeleteExtractionClicked(e)}>
                        {t('private_area.game_extractions_tab.delete_button_text')}
                    </Button>
                </div>
                <div className="d-flex flex-column gap-3">
                    {extraction.games.map((game) => (
                        <div key={game.link} className="card border-0 shadow-sm">
                            <div className="card-body p-3 d-flex gap-3 align-items-start">
                                {game.image_link && (
                                    <img
                                        src={game.image_link}
                                        alt={game.name}
                                        className="rounded flex-shrink-0"
                                        style={{ width: 64, height: 64, objectFit: 'cover' }}
                                    />
                                )}
                                <div className="flex-grow-1 min-w-0">
                                    <a href={game.link} target="_blank" rel="noreferrer"
                                        className="fw-semibold text-dark text-decoration-none">
                                        {game.name}
                                    </a>
                                    {game.description && (
                                        <p className="text-clamp text-muted small mb-2 mt-1">
                                            {game.description}
                                        </p>
                                    )}
                                    <div className="d-flex gap-2 mt-2">
                                        <Button
                                            size="sm"
                                            variant={game.selected ? 'warning' : 'outline-secondary'}
                                            onClick={(e) => onSelectGameClicked(e, extraction.game_extraction_id, game.game_extraction_result_id, !game.selected)}>
                                            <StarFill size={13} className="me-1" />
                                            {game.selected
                                                ? t('private_area.game_extractions_tab.unselect_game_button_text')
                                                : t('private_area.game_extractions_tab.select_game_button_text')}
                                        </Button>
                                        <Button size="sm" variant="outline-secondary"
                                            onClick={() => onSearchProductClicked(game.name)}>
                                            {t('private_area.game_extractions_tab.search_button_text')}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Accordion.Body>
        </Accordion.Item>
    );
}

export default GameExtraction;
